<template>

<app-input-wrapper :slim="slim" :value="value" :note="note" :label="label" :errored="errored" :class="{'is-errored': errored}">

	<com-picker type="text" :value="dateValue" format="HH:mm" :minute-interval="15" input-class="input-picker-input" :placeholder="placeholder" v-on:change="onSelected" class="input-picker" />

</app-input-wrapper>

</template>

<script>

import mixinInput from '@/mixin/input.js'
import comPicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {

	mixins: [mixinInput],

	components: {
		'com-picker': comPicker
	},

	computed: {

		dateValue: function() {

			return (this.value) ? this.$moment.unix(this.value).format('HH:mm') : ''

		}

	},

	methods: {

		onSelected: function(e) {

			this.onValueChange(this.$moment().hour(parseInt(e.data.HH)).minute(parseInt(e.data.mm)).utc().unix())

		}

	}

}

</script>

<style scoped>

.input >>> .vue__time-picker .dropdown {
    border: 1px solid var(--color-grey-highlight);
    border-radius: 0px 0px 4px 4px;
    top: 39px;
    width: 160px;
}

.input >>> .input-picker {
    width: 100%;
}

.input >>> .input-picker-input {
	border: 1px solid var(--color-grey-light);
	height: 40px;
	border-radius: 4px;
	transition: all 100ms linear;
	width: 100%;
	font-size: 14px;
	color: var(--color-grey-dark);
	padding: 0px 10px;
}

.input.is-expanded >>> .input-picker-input {
	border-radius: 4px 4px 4px 0px;
}

.input.is-errored >>> .input-picker-input {
	border-color: var(--color-red-light);
}

.is-desktop .input:hover >>> .input-picker-input {
	border-color: var(--color-grey-highlight);
}

.is-desktop .input.is-errored:hover >>> .input-picker-input {
	border-color: var(--color-red-light);
}

.input >>> .input-picker-input::placeholder {
	color: var(--color-grey);
}

.input >>> .input-picker-calendar {
	border-radius: 0px 0px 4px 4px;
	border-top-width: 0px;
	border-color: var(--color-grey-light);
}

.input:hover >>> .input-picker-calendar {
	border-color: var(--color-grey-highlight);
}

</style>